module.exports = __webpack_public_path__ + "img/course.6c78325e.png";